import { NavLink } from 'react-router-dom';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import styled from '@mui/styled-engine';
import theme from '../../../themes/mainTheme';

interface Props {
  Icon: JSX.Element,
  isChild?: boolean
  name: string,
  to: string,
}

const NavLinkStyled = styled(NavLink)({
  textDecoration: 'none',
  color: theme.palette.text.primary
})

export const MyNavLink = ({ to, Icon, name, isChild }: Props) => {
  return (
    <NavLinkStyled to={to} >
      <ListItemButton sx={{ pl: (isChild ? 4 : 2) }}>
        <ListItemIcon>
          {Icon}
        </ListItemIcon>
        <ListItemText primary={name} />
      </ListItemButton>
    </NavLinkStyled>
  )
}
